import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

import {FacilitiesGridLoader} from '../Facilities/FacilitiesGrid'

const LocationTextColumn = styled.div`
  display: contents;

  ${linariaMq.desktopSm} {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${cssTheme.layout.spacing.s600};
  }
`

const LocationAttractions = styled.div`
  order: 2;
`

const MapArea = styled.div`
  order: 1;
  padding-block: ${cssTheme.layout.spacing.s200};

  ${linariaMq.desktopSm} {
    order: 0;
    flex: 1;
    padding-block: 0;
    align-self: stretch;
  }
`

const MapBox = styled.div`
  height: 140px;
  border-radius: ${cssTheme.layout.radius.lg};
  overflow: hidden;

  ${linariaMq.desktopSm} {
    height: 100%;
    min-height: 240px;
  }
`

const PropertyInfoLoading = () => (
  <Box display="flex" flexDirection="column" gap="s700">
    <Box display="flex" flexDirection="column" gap="s600">
      <SkeletonLoader width={200} />
      <div>
        <SkeletonLoader />
        <SkeletonLoader width={375} />
      </div>
    </Box>
    <FacilitiesGridLoader
      items={4}
      columns={2}
      variant="secondary"
      rowGap="s400"
    />
  </Box>
)

const LocationLoading = () => (
  <Box
    display="flex"
    flexDirection="column"
    gap="s300"
    desktopSm={{
      flexDirection: 'row',
      columnGap: 's600',
      alignItems: 'flex-start'
    }}
  >
    <LocationTextColumn>
      <div>
        <SkeletonLoader width={120} />
        <SkeletonLoader width={241} />
      </div>
      <LocationAttractions>
        <SkeletonLoader width={172} />
        <SkeletonLoader width={124} />
      </LocationAttractions>
    </LocationTextColumn>
    <MapArea>
      <MapBox>
        <SkeletonLoader height="100%" />
      </MapBox>
    </MapArea>
  </Box>
)

export const HotelOverviewLoading: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      desktopXs={{flexDirection: 'row'}}
      gap="s900"
    >
      <Box flex="1 0 0" minWidth="0">
        <PropertyInfoLoading />
      </Box>
      <Box flex="1 0 0" minWidth="0" display="flex" flexDirection="column">
        <LocationLoading />
      </Box>
    </Box>
  )
}
